import api from '../api';

export const getOneConfig = async (id) => {
    const result = await api.get(`/admin/config/${id}`);
    return result.data;
}

export const updateConfig = async (data, id) => {
    return await api.post(`/admin/config/${id}`, data);
}



